// Loads Google Identity Services on demand.
//
// The script is injected the first time a Google button is rendered rather than
// sitting in index.html, so visitors who never open the auth modal do not pay
// for it. Every caller shares the same promise, so it is only ever fetched once.

const GSI_SRC = "https://accounts.google.com/gsi/client";

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

let loaderPromise = null;

export const isGoogleAuthConfigured = () => Boolean(GOOGLE_CLIENT_ID);

export const loadGoogleIdentity = () => {
    if (window.google?.accounts?.id) {
        return Promise.resolve(window.google.accounts.id);
    }

    if (loaderPromise) return loaderPromise;

    loaderPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src="${GSI_SRC}"]`);

        const onLoad = () => {
            if (window.google?.accounts?.id) {
                resolve(window.google.accounts.id);
            } else {
                loaderPromise = null;
                reject(new Error("Google Identity Services loaded without the expected API"));
            }
        };

        const onError = () => {
            // let the next attempt retry instead of caching the failure forever
            loaderPromise = null;
            reject(new Error("Could not load Google Identity Services"));
        };

        if (existing) {
            existing.addEventListener("load", onLoad);
            existing.addEventListener("error", onError);
            return;
        }

        const script = document.createElement("script");
        script.src = GSI_SRC;
        script.async = true;
        script.defer = true;
        script.addEventListener("load", onLoad);
        script.addEventListener("error", onError);
        document.head.appendChild(script);
    });

    return loaderPromise;
};
